import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styles from './BottomNavBar.module.scss'
import Grid from '@/config/Grid/Grid'
import Button from '../Button/Button'

function BottomNavBar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const navItems = [
    {
      path: '/tables-list',
      icon: 'las la-chair icon-large',
      label: t('BOTTOM_NAV.TABLES')
    },
    {
      path: '/active-order',
      icon: 'las la-file-invoice icon-large',
      label: t('BOTTOM_NAV.ACTIVE_ORDER')
    }
  ]

  const isActive = (path: string) => {
    if (path === '/tables-list') {
      return pathname === '/' || pathname === '/tables-list'
    }
    if (path === '/active-order') {
      return pathname.startsWith('/table/') && !pathname.includes('/historical')
    }
    return pathname.startsWith(path)
  }

  const isDisabled = (path: string) => {
    if (path === '/active-order') {
      return (
        pathname === '/' ||
        pathname === '/tables-list' ||
        isActive('/active-order')
      )
    }
    if (path === '/tables-list') {
      return isActive('/tables-list')
    }
    return false
  }

  return (
    <Grid>
      <nav className={`start-1 col-12 ${styles.bottomNav}`}>
        {navItems.map(item => (
          <Button
            key={item.path}
            icon={item.icon}
            label={item.label}
            variant="contained"
            color={isActive(item.path) ? 'secondary' : 'primary'}
            onClick={() => navigate(item.path)}
            mobile
            disabled={isDisabled(item.path)}
          />
        ))}
      </nav>
    </Grid>
  )
}

export default BottomNavBar
